import React, { useEffect, useState } from "react";
import clsx from "clsx";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { useCreateData, useUpdateData } from "hooks/useApiHooks";
import { IconUpload } from "@tabler/icons-react";
import { API_URL } from "utils/constants";

const MasterDataForm = ({
  title,
  apiUrl,
  initialData,
  fields = [],
  onSuccess,
  onError,
}) => {
  const isUpdateMode = initialData && Object.keys(initialData).length > 0;

  // 🔹 **Inisialisasi formData dengan initialData saat mode edit**
  const [formData, setFormData] = useState({});

  // useEffect(() => {
  //   if (isUpdateMode) {
  //     setFormData(initialData);
  //   } else {
  //     const defaultValues = {};
  //     fields.forEach((field) => {
  //       defaultValues[field.name] = field.type === "checkbox" ? false : "";
  //     });
  //     setFormData(defaultValues);
  //   }
  // }, [initialData, fields, isUpdateMode]);

  useEffect(() => {
    const defaultValues = {};
    fields.forEach((field) => {
      if (field.type === "checkbox") {
        defaultValues[field.name] = false;
      } else if (field.type === "multiselect") {
        defaultValues[field.name] = [];
      } else {
        defaultValues[field.name] = "";
      }
    });

    if (isUpdateMode) {
      const prefill = { ...defaultValues };

      Object.keys(initialData).forEach((key) => {
        if (key === "is_active") {
          prefill[key] = String(initialData[key]);
        } else {
          prefill[key] = initialData[key];
        }
      });

      // ❗️Override khusus untuk category_ids
      if (
        (!initialData.category_ids || initialData.category_ids.length === 0) &&
        Array.isArray(initialData.categories)
      ) {
        prefill["category_ids"] = initialData.categories.map((cat) => cat.id);
      }

      setFormData(prefill);
    } else {
      setFormData(defaultValues);
    }
  }, [initialData, fields, isUpdateMode]);

  // const [selectedFile, setSelectedFile] = useState(null);

  // const { createData, loading: creating } = useCreateData(apiUrl);
  // const { updateData, loading: updating } = useUpdateData(
  //   `${apiUrl}/${initialData?.id}`
  // );

  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(
    initialData?.image_url || ""
  ); // ✅ Simpan gambar lama

  const formatNumber = (value) => {
    const number = value.replace(/\D/g, "");
    return new Intl.NumberFormat("id-ID").format(Number(number));
  };

  const unformatNumber = (value) => {
    return value.replace(/\./g, "");
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    // 🔹 Untuk field price atau min_price
    if (["price", "min_price"].includes(name)) {
      const formatted = formatNumber(value); // untuk tampil
      const raw = unformatNumber(formatted); // untuk dikirim
      setFormData((prev) => ({
        ...prev,
        [name]: raw,
        [`${name}_display`]: formatted, // ← simpan tampilan terformat
      }));
      return;
    }

    // 🔹 Field lain
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (type === "file") {
      const file = files[0];
      if (file) {
        setSelectedFile(file);
        setImagePreview(URL.createObjectURL(file));
      }
    }
  };

  // const handleChangeV3 = (e) => {
  //   const { name, value, type, checked, files } = e.target;

  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));

  //   if (type === "file") {
  //     const file = files[0];

  //     if (file) {
  //       setSelectedFile(file); // ✅ Simpan file baru
  //       setImagePreview(URL.createObjectURL(file)); // ✅ Tampilkan preview
  //     }
  //   }
  // };

  // const handleChangeV2 = (e) => {
  //   const { name, value, type, checked, files } = e.target;

  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));

  //   if (type === "file") {
  //     const file = files[0];

  //     if (file) {
  //       setSelectedFile(file);
  //       setImagePreview(URL.createObjectURL(file)); // ✅ Tampilkan preview file baru
  //     }
  //   }
  // };

  // const handleChangeV1 = (e) => {
  //   const { name, value, type, checked, files } = e.target;

  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]:
  //       type === "checkbox" ? checked : type === "file" ? files[0] : value,
  //   }));

  //   if (type === "file") {
  //     setSelectedFile(files[0]?.name || "");
  //   }
  // };

  const handleSelectChange = (selectedOption, field) => {
    setFormData((prev) => ({
      ...prev,
      [field.name]: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleDateChange = (date, field) => {
    setFormData((prev) => ({
      ...prev,
      [field.name]: date,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const submitData = new FormData();

      // 🔹 Tambahkan semua field kecuali `image` jika tidak ada file baru
      // Object.keys(formData).forEach((key) => {
      //   if (
      //     formData[key] !== null &&
      //     formData[key] !== undefined &&
      //     key !== "image_url" // ✅ Jangan kirim `image_url`
      //   ) {
      //     if (
      //       formData.recorded_at &&
      //       typeof formData.recorded_at === "string" &&
      //       formData.recorded_at.includes("T")
      //     ) {
      //       const [date, time] = formData.recorded_at.split("T");
      //       formData.recorded_at = `${date} ${time}:00`; // ✅ format: 2025-03-31 13:13:00
      //     }

      //     submitData.append(key, formData[key]);
      //   }
      // });

      Object.keys(formData).forEach((key) => {
        const value = formData[key];

        // khusus array seperti category_ids[]
        if (Array.isArray(value)) {
          value.forEach((val, idx) => {
            submitData.append(`${key}[${idx}]`, val);
          });
        } else if (
          value !== null &&
          value !== undefined &&
          key !== "image_url"
        ) {
          // khusus untuk datetime field
          if (
            key === "recorded_at" &&
            typeof value === "string" &&
            value.includes("T")
          ) {
            const [date, time] = value.split("T");
            submitData.append(key, `${date} ${time}:00`);
          } else {
            submitData.append(key, value);
          }
        }
      });

      // 🔹 Jika ada file baru, tambahkan ke FormData
      if (selectedFile) {
        submitData.append("image", selectedFile);
      } else {
        // 🔥 Hapus `image` dari FormData jika tidak ada file baru
        submitData.delete("image");
      }

      // 🔹 Jika update, tambahkan `_method: "PUT"`
      if (isUpdateMode) {
        submitData.append("_method", "PUT");
      }

      const token = localStorage.getItem("token"); // 🔥 Ambil token untuk autentikasi
      const url = isUpdateMode
        ? `${API_URL}${apiUrl}/${initialData?.id}`
        : `${API_URL}${apiUrl}`;

      const response = await fetch(url, {
        method: "POST", // Gunakan POST karena ada `_method: PUT`
        body: submitData,
        headers: {
          Authorization: `Bearer ${token}`, // 🔥 Tambahkan token di sini
        },
      });

      const result = await response.json();

      if (response.ok) {
        onSuccess(result);
      } else {
        onError(result);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="d-flex flex-column">
      <div className="action-sheet-content flex-grow-1">
        {fields.map((field) => (
          <div className="row mb-3 align-items-center" key={field.name}>
            <label className="col-sm-4 col-form-label d-flex justify-content-end">
              {field.label}:
            </label>
            <div className="col-sm-8">
              {["text", "number", "password", "email", "tel"].includes(
                field.type
              ) && (
                // <input
                //   type={field.type}
                //   className={clsx("form-control")}
                //   name={field.name}
                //   value={formData[field.name] || ""}
                //   onChange={handleChange}
                // />
                <input
                  type={field.type}
                  className={clsx("form-control")}
                  name={field.name}
                  value={
                    ["price", "min_price"].includes(field.name)
                      ? formData[`${field.name}_display`] || ""
                      : formData[field.name] || ""
                  }
                  onChange={handleChange}
                />
              )}

              {field.type === "textarea" && (
                <textarea
                  className="form-control"
                  name={field.name}
                  rows={field.rows || 3}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                />
              )}

              {field.type === "select" && (
                <Select
                  options={field.options}
                  value={
                    field.options.find(
                      (opt) => opt.value === formData[field.name]
                    ) || ""
                  }
                  onChange={(selected) => handleSelectChange(selected, field)}
                  isSearchable
                  placeholder={`Pilih ${field.label}`}
                />
              )}

              {/* {field.type === "multiselect" && (
                <Select
                  options={field.options}
                  isMulti
                  closeMenuOnSelect={false}
                  value={field.options.filter((opt) =>
                    (formData[field.name] || []).includes(opt.value)
                  )}
                  onChange={(selected) => {
                    const selectedValues = selected.map((item) => item.value);
                    setFormData((prev) => ({
                      ...prev,
                      [field.name]: selectedValues,
                    }));
                  }}
                  placeholder={`Select ${field.label}`}
                />
              )} */}

              {field.type === "multiselect" && (
                <Select
                  options={field.options}
                  isMulti
                  closeMenuOnSelect={false}
                  value={field.options.filter((opt) =>
                    (formData[field.name] || []).includes(opt.value)
                  )}
                  onChange={(selected) => {
                    const selectedValues = selected.map((item) => item.value);
                    setFormData((prev) => ({
                      ...prev,
                      [field.name]: selectedValues,
                    }));
                  }}
                  placeholder={`Select ${field.label}`}
                />
              )}

              {/* {field.type === "radio" &&
                field.options?.map((option) => (
                  <div
                    className="form-check form-check-inline"
                    key={option.value}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name={field.name}
                      value={option.value}
                      checked={formData[field.name] === option.value}
                      onChange={handleChange}
                    />
                    <label className="form-check-label">{option.label}</label>
                  </div>
                ))} */}
              {field.type === "radio" &&
                field.options?.map((option) => (
                  <div
                    className="form-check form-check-inline"
                    key={option.value}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name={field.name}
                      value={option.value}
                      checked={formData[field.name] === option.value}
                      onChange={handleChange}
                    />
                    <label className="form-check-label">{option.label}</label>
                  </div>
                ))}

              {field.type === "checkbox" && (
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name={field.name}
                    checked={formData[field.name] || false}
                    onChange={handleChange}
                  />
                  <label className="form-check-label">{field.label}</label>
                </div>
              )}

              {field.type === "date" && (
                <DatePicker
                  selected={formData[field.name]}
                  onChange={(date) => handleDateChange(date, field)}
                  className="form-control"
                  dateFormat="yyyy-MM-dd"
                />
              )}

              {field.type === "file" && (
                <div className="input-group">
                  <input
                    type="file"
                    className="form-control"
                    name={field.name}
                    onChange={handleChange}
                  />
                  <span className="input-group-text">
                    <IconUpload size={18} />
                  </span>
                </div>
              )}

              {field.type === "datetime-local" && (
                <input
                  type="datetime-local"
                  className="form-control"
                  name={field.name}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                />
              )}

              {/* {selectedFile && (
                <p className="mt-1 text-muted">File: {selectedFile}</p>
              )} */}
            </div>
          </div>
        ))}

        {imagePreview && (
          <div className="row mb-3 align-items-center">
            <label className="col-sm-4 col-form-label d-flex justify-content-end">
              Image Preview:
            </label>
            <div className="col-sm-8">
              <img
                src={imagePreview}
                alt="Preview"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
              />
            </div>
          </div>
        )}
      </div>
      {/* print json */}
      {/* <div className="row mb-3 align-items-center">
        <label className="col-sm-4 col-form-label d-flex justify-content-end">
          JSON:
        </label>
        <div className="col-sm-8">
          <pre>{JSON.stringify(formData, null, 2)}</pre>
        </div>
      </div> */}
      <div className="form-group mt-auto d-grid">
        <button type="submit" className="btn btn-primary btn-block">
          {isUpdateMode ? "Update" : "Create"}
        </button>
      </div>
    </form>
  );
};

export default MasterDataForm;
